import { useMutation, useQuery } from "@tanstack/react-query";
import { reportService } from "../services/reportService";
import { ExportReportRequest } from "../types/reports";

const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const useReportColumns = (reportType: string | null) => {
  return useQuery({
    queryKey: ["reportColumns", reportType],
    queryFn: () => reportService.getAvailableColumns(reportType!),
    enabled: !!reportType,
  });
};

export const useExportReport = () => {
  return useMutation({
    mutationFn: async (request: ExportReportRequest) => {
      const blob = await reportService.exportReport(request);
      const filename = `${request.reportType}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      downloadBlob(blob, filename);
      return blob;
    },
  });
};

export const useEstimateRowCount = () => {
  return useMutation({
    mutationFn: (request: ExportReportRequest) =>
      reportService.estimateRowCount(request),
  });
};
